// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3aQ9T","col":"Table_col__1lM6Y","fulfillmentStatus":"Table_fulfillmentStatus__353bU","emailCol":"Table_emailCol__3nFfd"};